export default function attachPropertiesToComponent(component, properties) {
  var ret = component;
  Object.keys(properties).forEach(function (key) {
    if (Object.prototype.hasOwnProperty.call(properties, key)) {
      ret[key] = properties[key];
    }
  });
  return ret;
}